import { render, staticRenderFns } from "./CryptoLongsleeveTshirt.vue?vue&type=template&id=351b2ade"
import script from "./CryptoLongsleeveTshirt.vue?vue&type=script&lang=js"
export * from "./CryptoLongsleeveTshirt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports